import './Div/index.js';
import './Image/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from './Div/Div.js';
import { Image } from './Image/Image.js';
function ImageFullWidth({
  src = '',
  altText = 'image'
}) {
  if (!src) return null;
  return /*#__PURE__*/jsx(Div, {
    css: {
      width: '100vw',
      maxWidth: '100vw',
      marginLeft: 'calc(50% - 50vw)',
      '> div': {
        height: 'auto'
      }
    },
    children: /*#__PURE__*/jsx(Image, {
      src: src,
      alt: altText,
      width: "100%",
      loading: "lazy",
      maxHeight: 478
    })
  });
}
export { ImageFullWidth };
//# sourceMappingURL=ImageFullWidth.js.map
